import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { getFeaturedArticles } from "../../../data/resources";

function ResourcesFeatured() {
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="py-16 px-4 bg-[#fff5eb]">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl font-bold mb-4 text-[#694e42]">Getting Started</h2>
          <p className="text-lg text-[#8a7266] max-w-2xl mx-auto">
            <span className="text-[#ff8c42] font-medium">First time using MailMaid?</span> We've put together these articles covering the basics.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {featuredArticles.map((article, index) => (
            <motion.div
              key={article.id}
              className="group block bg-white rounded-xl overflow-hidden shadow-sm border border-[#e2dad3]"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10, boxShadow: "0 15px 30px rgba(0, 0, 0, 0.1)" }}
            >
              <Link to={`/resources/${article.categoryId}#${article.id}`} className="block">
                <div className="relative overflow-hidden h-48">
                  <img 
                    src={article.featuredImage || "/api/placeholder/600/400"} 
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm py-1 px-2 rounded-md text-xs font-medium text-[#694e42]">
                    {article.categoryName}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#694e42] mb-2 group-hover:text-[#ff8c42] transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-[#8a7266]">{article.excerpt}</p>
                  <div className="mt-4 flex items-center text-[#ff8c42] font-medium">
                    Read article
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 ml-1 transition-transform duration-300 group-hover:translate-x-1">
                      <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ResourcesFeatured;